/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const SendChatPrompt: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={color}
      d="M13.4897 19.2562C13.1749 18.931 13.1749 18.4039 13.4897 18.0788L15.3377 16.1699H10.6343C8.07483 16.1699 6 14.0267 6 11.3829V5.33252C6 4.87273 6.36084 4.5 6.80596 4.5C7.25108 4.5 7.61192 4.87273 7.61192 5.33252V11.3829C7.61192 13.1071 8.96507 14.5049 10.6343 14.5049H15.1589L13.4897 12.7806C13.1749 12.4555 13.1749 11.9284 13.4897 11.6033C13.8044 11.2781 14.3147 11.2781 14.6295 11.6033L17.7639 14.841C18.0787 15.1661 18.0787 15.6933 17.7639 16.0184L14.6295 19.2562C14.3147 19.5813 13.8044 19.5813 13.4897 19.2562Z" />
  </svg>
}
